var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErgopadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M636.166 1365.2L1001.88 1999.99L1708.43 1705.76L1000.97 1515.5L636.166 1365.2Z",
    fill: "url(#paint0_linear_58_286)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M634.788 636.158L790.711 571.229L998.113 0L634.788 636.158Z",
    fill: "#40B3B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1705.77 291.553L998.113 0L790.712 571.228L999.026 484.488L1705.77 291.553Z",
    fill: "url(#paint1_linear_58_286)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M999.024 484.488L1109.17 529.859L1624.29 313.801L999.024 484.488Z",
    fill: "#0C3E4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.21 1363.83L2000 998.113L1417.92 1235.88L1365.21 1363.83Z",
    fill: "#40B3B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1515.51 999.025L1417.91 1235.88L2000 998.112L1705.77 291.552L1515.51 999.025Z",
    fill: "url(#paint2_linear_58_286)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.97 1515.5L1708.43 1705.76L1126.38 1463.28L1000.97 1515.5Z",
    fill: "#31919B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.21 1363.83L1126.38 1463.28L1708.44 1705.76L2000 998.113L1365.21 1363.83Z",
    fill: "url(#paint3_linear_58_286)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M484.489 1000.96L291.563 294.225L0 1001.87L628.999 1348L484.489 1000.96Z",
    fill: "url(#paint4_linear_58_286)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M636.167 1365.2L628.999 1348L0 1001.87L294.225 1708.43L1001.88 1999.99L636.167 1365.2Z",
    fill: "#1C637B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M484.487 1000.96L538.413 870.07L291.561 294.225L484.487 1000.96Z",
    fill: "#31919B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M998.112 0L291.561 294.225L538.413 870.071L634.787 636.158L998.112 0Z",
    fill: "url(#paint5_linear_58_286)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1515.51 999.024L1705.78 291.561C1705.78 291.561 1536.72 736.859 1475.36 902.622L1515.51 999.024Z",
    fill: "#0C3E4F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.17 529.859L1363.83 634.779L1475.36 902.604C1536.71 736.841 1705.77 291.543 1705.77 291.543L1624.29 313.782L1109.17 529.859Z",
    fill: "#1C637B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_286",
    x1: 1166.03,
    y1: 1554.13,
    x2: 1014.66,
    y2: 2004.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3197AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_286",
    x1: 891.72,
    y1: 285.959,
    x2: 1430.98,
    y2: 217.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_58_286",
    x1: 1417.92,
    y1: 763.719,
    x2: 1999.99,
    y2: 763.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_58_286",
    x1: 1642.15,
    y1: 1588.4,
    x2: 1550.79,
    y2: 1174.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3599A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_58_286",
    x1: -11.7757,
    y1: 1059.97,
    x2: 549.464,
    y2: 775.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3197AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297F92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_58_286",
    x1: 436.982,
    y1: 555.62,
    x2: 800.873,
    y2: 116.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3599A3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErgopadIcon);
export default __webpack_public_path__ + "static/media/ergopadIcon.14d00d31237bd3ba2114599ef69e1af8.svg";
export { ForwardRef as ReactComponent };